import { ref, reactive } from "vue";
import { useRoute } from "vue-router";
import { queryCustomFormById, updateCustomForm } from "@/api/customForm";
import { ElMessage } from "element-plus";

export default function useFormGenerator() {
  const formData = reactive({
    id: null,
    content: null,
  });
  // route
  const route = useRoute();
  // 组件ref
  const designer = ref(null);

  // 表单组件配置项
  const designerConfig = reactive({
    generateSFCButton: false,
  });

  // 点击保存
  const handleSave = () => {
    const result = designer.value.getFormJson();
    formData.content = JSON.stringify(result);

    updateCustomForm({ ...formData }).then((res) => {
      if (res.code == "2000") {
        ElMessage.success("保存成功");
      }
    });
  };

  // 通过id获取表单
  const queryFormById = (id) => {
    queryCustomFormById(id)
      .then((res) => {
        formData.id = id;
        formData.content = res.data.content;
      })
      .finally(() => {
        if (!formData.content) return designer.value?.clearDesigner();
        designer.value?.setFormJson(formData.content);
      });
  };
  return {
    route,
    designer,
    designerConfig,
    handleSave,
    queryFormById,
  };
}
